module.exports = __webpack_public_path__ + "static/media/hiw2blue.e857cdf2.svg";